import React from "react";

const ServiceCard = ({ icon, title, description, delay = ".2s" }) => {
  return (
    <div
      className="wow fadeInUp group mx-auto max-w-[310px] text-center"
      data-wow-delay={delay}
    >
      <div className="mx-auto mb-8 flex h-[90px] w-[90px] items-center justify-center rounded-3xl bg-primary text-white duration-300 group-hover:bg-gray group-hover:text-primary dark:bg-primary dark:text-white dark:group-hover:bg-[#2A2E44] dark:group-hover:text-white">
        {" "}
        {icon}
      </div>
      <h3 className="mb-4 text-xl font-semibold text-black dark:text-white sm:text-[22px] xl:text-[26px]">
        {title}
      </h3>
      <p className="text-base text-body">{description}</p>
    </div>
  );
};

export default ServiceCard;
